var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileiconactive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0002 5.33334H14.3602C14.1274 4.7166 13.7658 4.15659 13.2995 3.69067L10.9768 1.36667C10.5104 0.900879 9.9502 0.539561 9.3335 0.306671V4.66667C9.3335 4.84348 9.40373 5.01305 9.52876 5.13808C9.65378 5.2631 9.82335 5.33334 10.0002 5.33334Z",
    fill: "#1E7C88"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6508 6.66667H10.0002C9.46973 6.66667 8.96102 6.45595 8.58595 6.08088C8.21088 5.70581 8.00016 5.1971 8.00016 4.66667V0.016C7.89283 0.00866667 7.7855 0 7.67683 0H4.66683C3.7831 0.00105857 2.93587 0.352588 2.31098 0.97748C1.68608 1.60237 1.33455 2.4496 1.3335 3.33333V12.6667C1.33455 13.5504 1.68608 14.3976 2.31098 15.0225C2.93587 15.6474 3.7831 15.9989 4.66683 16H11.3335C12.2172 15.9989 13.0645 15.6474 13.6894 15.0225C14.3142 14.3976 14.6658 13.5504 14.6668 12.6667V6.99C14.6668 6.88133 14.6582 6.774 14.6508 6.66667Z",
    fill: "#1E7C88"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileiconactive);
export default __webpack_public_path__ + "static/media/fileiconactive.a85789f01c65851999454bf87455d2c8.svg";
export { ForwardRef as ReactComponent };